<script setup>
import { DsIcon, DsInputMasked} from '@ds/vue2'
import { computed, ref, toRefs, watch } from 'vue';

const emit = defineEmits(['input', 'pickContact', 'blur'])
const props = defineProps({
  value: {
    type: String,
    required: true
  },
  label: {
    type: String
  },
  rules: {
    type: Array,
    default: () => []
  }
})

const {rules, value} = toRefs(props)

const triggerValidation = () => {
  for (const rule of rules.value) {
    const result = rule(localValue.value) 
    if (typeof result === 'string') {
      currentErrorMessage.value = result
      isError.value = true
      return
    }
  }
  isError.value = false

  return isError.value // Для внешних вызовов, возвращаем состояние валидации
}

const localValue = ref('')
watch(localValue, (newVal) => {
  triggerValidation()
  emit('input', newVal)
})

watch(value, (propsValue) => {
  localValue.value = propsValue
})

const currentErrorMessage = ref('')

const isError = ref(false)
const allowValidation = ref(false)

const errorMessage = computed(() => {
  return isError.value && allowValidation.value ? currentErrorMessage.value : null
})

defineExpose({
  triggerValidation
})

const onInputBlut = (event) => {
  emit('blur', event)
  allowValidation.value = true
}
</script>

<template>
  <DsInputMasked @blur="onInputBlut" type="tel" v-model="localValue" :error="errorMessage" :label="label" mask="phone">
    <template #append>
      <DsIcon @click.native="$emit('pickContact')" name="system/contacts-500" color="icon-brand"></DsIcon>
    </template>
  </DsInputMasked>
</template>